import { FORM_ERROR } from "final-form";

/**
 * checks if fields that have submitErrors have been changed since last form submission
 *
 * @param {Object} submitErrors https://final-form.org/docs/final-form/types/FormState#submiterrors.
 * @param {Object} dirtyFieldsSinceLastSubmit https://final-form.org/docs/final-form/types/FormState#dirtyfieldssincelastsubmit.
 * @return {Boolean} true if every field with a submitError has been changed since last form submission
 */
const submitErrorFieldsHaveChanged = (
  submitErrors = {},
  dirtyFieldsSinceLastSubmit = {}
) => {
  const { [FORM_ERROR]: _, ...fieldSubmitErrors } = submitErrors;
  return Object.keys(fieldSubmitErrors).every(field =>
    Boolean(dirtyFieldsSinceLastSubmit[field])
  );
};

export default submitErrorFieldsHaveChanged;
